import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './styles.module.css';
import { setShipmentFilterVisibility, searchTrackingNo } from '../../actions';
import { SearchableSelect } from '../../../../../common/ui';
import FilterModal from '../../../../../common/components/FilterModal';

const FilterComp = ({
  shipment: { isShipmentFiltersOpen, suggestTrackingNo },
  setShipmentFilterVisibility,
  filters,
  setFilters,
  searchTrackingNo,
  selectedTrackingNo,
  SetSelectedTrackingNo,
}) => {
  const handleApply = () => {
    const newFilters = {};
    if (selectedTrackingNo) {
      newFilters.trackingNo = selectedTrackingNo;
    }
    setFilters(newFilters);
    setShipmentFilterVisibility(false);
  };

  const filterContent = (
    <>
      <div className={styles.filterOptionName}>By Tracking No</div>
      <SearchableSelect
        async
        options={suggestTrackingNo || []}
        getOptionLabel={(o) => o.trackingNo ?? o.tracking_no ?? '—'}
        getOptionValue={(o) => o.id ?? o.trackingNo}
        value={selectedTrackingNo?.id ?? selectedTrackingNo?.trackingNo}
        onChange={(id) => {
          if (!id) SetSelectedTrackingNo(null);
        }}
        onSelect={(opt) => SetSelectedTrackingNo(opt)}
        onSearch={(keyword) => searchTrackingNo(keyword)}
        placeholder="Enter Tracking No"
        minSearchLength={1}
      />
    </>
  );

  return (
    <FilterModal title="Filter by" onApply={handleApply}>
      {filterContent}
    </FilterModal>
  );
};

FilterComp.propTypes = {
  setShipmentFilterVisibility: PropTypes.func.isRequired,
  searchTrackingNo: PropTypes.func.isRequired,
  shipment: PropTypes.shape({
    isShipmentFiltersOpen: PropTypes.bool,
    suggestTrackingNo: PropTypes.array,
  }).isRequired,
  filters: PropTypes.object,
  setFilters: PropTypes.func.isRequired,
  selectedTrackingNo: PropTypes.object,
  SetSelectedTrackingNo: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  shipment: state.shipmentsState,
});

export default connect(mapStateToProps, {
  setShipmentFilterVisibility,
  searchTrackingNo,
})(FilterComp);
